import React, { Component } from 'react';
import { connect, } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown'
import { Link, } from 'react-router-dom';
import { withRouter } from '../withRouter';
import { logout } from "actions/auth.js";
import styles from "components/Layout/NavStyles.module.scss";
import logo from '../../images/logo.png';
import basketIcon from '../../images/icons/basketIcon.png';
import burgerMenu from '../../images/icons/burgerMenu.png';
import newsletterIcon from "images/icons/NewsletterIcon.png";
import userIcon from '../../images/icons/userIcon.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXTwitter, faInstagram, faFacebook, faYoutube, faTiktok, faKickstarter, faLetterboxd } from "@fortawesome/free-brands-svg-icons";
import { APP_TYPES } from "constants/AppTypes";
import CRMModal from 'components/Modals/CRMModal/CRMModal';



class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.getUrl();

        this.state = {

            showUserMenu: false,
            showCRM: false,
        };
        this.wrapperRefOne = React.createRef();
        this.wrapperRefTwo = React.createRef();
        this.userButtonRef = React.createRef();
        this.menuButtonRef = React.createRef();
    }


    showUserMenu = () => {
        this.setState({ showUserMenu: true });
    }

    hideUserMenu = () => {
        this.setState({ showUserMenu: false });
    }

    toggleUserMenu = (e) => {
        console.log("user menu");
        this.setState({ showUserMenu: !this.state.showUserMenu });
    }

    isMenuShowing = () => {
        return this.state.showMenu ? styles.show : styles.hide;
    }

    getUrl = () => {
        return window.location.href;
    }


    isAGameStorePage = () => {
        const availableGameSlugs = [
            'herd-mentality',
            'can-of-squirms',
            'scrawl',
            'the-chameleon',
            'draw-along-with-dave',
            'colour-brain',
            'pub-quiz',
        ];


        const matchedGame = availableGameSlugs.find((x) => x === window.location.href.split('/').slice(-1)[0])

        switch (matchedGame) {
            case 'herd-mentality':
                return styles.herdMentality;
            case 'can-of-squirms':
                return styles.canOfSquirms;
            case 'scrawl':
                return styles.scrawl;
            case 'the-chameleon':
                return styles.theChameleon;
            case 'draw-along-with-dave':
                return styles.drawAlongWithDave;
            case 'colour-brain':
                return styles.colourBrain;
            case 'pub-quiz':
                return styles.pubQuiz;
            default:
                return null;
        }

    }

    doNavigation = (page) => {
        this.props.navigate(page);
    }

    logout = (e) => {
        e.preventDefault();
        this.props.logout();
        this.props.navigate("/login");
    }

    countCartQuanity = () => {
        // Counts the quantity of items in the cart

        // The last thing to get this working is for this method to run whenever the cart updates

        if (this.props.cart) {
            const cart = this.props.cart;
            let total = 0;

            cart.items.forEach(item => {
                total += item.quantity
            })

            return total;
        } else {
            return 0;
        }

    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    onCRMClose = () => {
        this.setState({ showCRM: false, })
    }

    render() {
        const pathname = window.location.pathname;
        const gameStyle = this.isAGameStorePage()
        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.devices.limitAccessFireTv;
        console.log("limitAccessFireTv from Redux:", this.props.devices.limitAccessFireTv)
        return (
            <>
                <header className={`${styles.header} ${gameStyle}`}>
                    <Container fluid className={styles.headerInner}>
                        <div className={`${styles.logo}`}>
                            <img onClick={() => !limitAccessFireTv && this.doNavigation("/")} src={logo} alt="" width="153" height="80"></img>
                        </div>
                        {
                            (!pathname.includes("lobby") && !pathname.includes("play")) ?
                                this.props.room.roomOpen ?
                                    <div className={styles.actionButtons}>
                                        <button onClick={() => this.props.navigate(this.props.room.isHost ? "/lobby" : "/join")} className={`${styles.button} ${styles.small}`}>RETURN TO LOBBY</button>
                                    </div>
                                :
                                <div className={styles.actionButtons}>
                                    <button onClick={() => this.props.navigate("/join")} className={`${styles.button} ${styles.small}`}>JOIN GAME</button>
                                    <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.small} ${styles.blueAlt}`}>HOST GAME</button>
                                </div>
                                :
                                null
                        }
                        <div className={`${styles.menuItems} ${styles.actions}`}>
                            <div ref={this.wrapperRefOne} className={`${styles.routes} ${this.isMenuShowing()} text-center`}>
                                <ul>
                                    <li>
                                        <Link className={`${window.location.pathname.includes("shop") && styles.selected}`} to="/shop">Shop</Link>
                                    </li>
                                    <li>
                                        <Link className={`${window.location.pathname.includes("help") && styles.selected}`} to="/help">Help</Link>
                                    </li>
                                    <li>
                                        <Link className={`${window.location.pathname.includes("redeem-code") && styles.selected}`} to="redeem-code">Redeem Code</Link>
                                    </li>
                                </ul>
                            </div>
                            <ul>
                                {
                                    !this.props.auth.isLoggedIn && !limitAccessFireTv &&
                                    <li className={`d-none d-md-block`}>
                                        <div className={styles.actionsItem} onClick={() => this.setState({ showCRM: true, })}>
                                            <img src={newsletterIcon} />
                                        </div>
                                    </li>
                                }
                                <li>
                                    {!limitAccessFireTv &&
                                        <>
                                            <Dropdown ref={this.wrapperRefTwo} className={`d-none d-md-block`}>
                                                <Dropdown.Toggle
                                                    as="div"
                                                    id="user-menu-dropdown"
                                                    className={`${styles.actionsItem} dropdown-toggle--custom`}
                                                >
                                                    <img src={userIcon} alt="User Menu" width="45" height="30" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    align="end"
                                                    className={styles.menu}
                                                    style={{ backgroundColor: "#210f37" }}
                                                >
                                                    {this.props.auth.isLoggedIn && (
                                                        <Dropdown.Item
                                                            className={styles.userNameMobile}
                                                            disabled
                                                        >
                                                            {this.props.auth.user?.userName ||
                                                                this.props.auth.user?.email}
                                                        </Dropdown.Item>
                                                    )}

                                                    {this.props.auth.isLoggedIn ? (
                                                        <>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={() => this.doNavigation("/lobby")}
                                                            >
                                                                My Games
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={this.logout}
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </>
                                                    ) : (
                                                        <Dropdown.Item
                                                            className={styles.userMenuItem}
                                                            onClick={() => this.doNavigation("/login")}
                                                        >
                                                            Login
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </>
                                    }
                                </li>
                                {!limitAccessFireTv &&
                                    <>
                                        <li>
                                            <div className={`${styles.actionsItem} d-none d-md-flex`}>
                                                <Link to="/checkout" className={styles.basketIcon}>
                                                    <img src={basketIcon} alt="" width="42" height="45" data-basket-count={this.countCartQuanity()}></img>
                                                    {
                                                        this.countCartQuanity() > 0 &&
                                                        <p className={styles.basketCount}>{this.countCartQuanity()}</p>
                                                    }
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <Dropdown className="d-lg-none">
                                                <Dropdown.Toggle
                                                    as="div"
                                                    id="menu-dropdown"
                                                    className={`${styles.actionsItem} dropdown-toggle--custom`}
                                                >
                                                    <img src={burgerMenu} alt="Menu" width="45" height="30" />
                                                </Dropdown.Toggle>

                                            <Dropdown.Menu align="end" className={styles.menu} style={{ backgroundColor: "#210f37" }} >
                                                {this.props.auth.isLoggedIn && (
                                                    <Dropdown.Item
                                                        className={styles.userNameMobile}
                                                        disabled
                                                    >
                                                        {this.props.auth.user?.userName ||
                                                            this.props.auth.user?.email}
                                                    </Dropdown.Item>
                                                )}
                                                    <Dropdown.Item className={`d-flex d-md-none ${styles.basketIcon}`} onClick={() => this.doNavigation("/checkout")}>
                                                        Cart
                                                        {
                                                            this.countCartQuanity() > 0 &&
                                                            <p className={styles.basketCount}>{this.countCartQuanity()}</p>
                                                        }
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/shop")}>Shop</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/help")}>Help</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/redeem-code")}>Redeem Code</Dropdown.Item>

                                                    {this.props.auth.isLoggedIn ? (
                                                        <>
                                                            <Dropdown.Item
                                                                className={`${styles.userMenuItem} d-flex d-md-none`}
                                                                onClick={() => this.doNavigation("/lobby")}
                                                            >
                                                                My Games
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                className={`${styles.userMenuItem} d-flex d-md-none`}
                                                                onClick={this.logout}
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Dropdown.Item
                                                                className={`${styles.userMenuItem} d-flex d-md-none`}
                                                                onClick={() => this.setState({ showCRM: true, })}
                                                            >
                                                                Newsletter
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                className={`${styles.userMenuItem} d-flex d-md-none`}
                                                                onClick={() => this.doNavigation("/login")}
                                                            >
                                                                Login
                                                            </Dropdown.Item>
                                                        </>

                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>
                                    </>
                                }
                            </ul>
                        </div>
                    </Container>
                </header>

                {
                    //window.location.pathname === '/' &&
                    //<header className={`${styles.socialsBar} ${gameStyle}`}>
                    //    <FontAwesomeIcon icon={faKickstarter} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/deal-or-no-deal-the-party-game-for-your-tv")} target="_blank" />
                    //    <FontAwesomeIcon icon={faXTwitter} onClick={() => this.openInNewTab("https://x.com/PlayGameCity")} target="_blank" />
                    //    <FontAwesomeIcon icon={faFacebook} onClick={() => this.openInNewTab("https://www.facebook.com/people/GameCity-Collective/61558537700430/")} target="_blank" />
                    //    <FontAwesomeIcon icon={faInstagram} onClick={() => this.openInNewTab("https://www.instagram.com/playgame.city/")} target="_blank" />
                    //    <FontAwesomeIcon icon={faTiktok} onClick={() => this.openInNewTab("https://www.tiktok.com/@gamecityplay")} target="_blank" />
                    //    <FontAwesomeIcon icon={faYoutube} onClick={() => this.openInNewTab("https://www.youtube.com/channel/UCQ2umAKfPvIbsdzaJvZWaKA")} target="_blank" />
                    //</header>
                }
                <CRMModal fromNav={true} show={this.state.showCRM} onClose={this.onCRMClose} />
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        cart: state.cart,
        devices: state.devices,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavMenu));